import { useContext } from 'react';

import { Field, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { WildCardRouteContext } from 'src/context/WildCardRoute/WildCardRouteContext';

import { SitecoreContextValue } from 'src/lib/ComponentProps';

import { FieldEditFrame } from 'src/utils/customFieldEditFrame';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import ContentOverviewCallToAction from './ContentOverviewCallToAction';
import { ContentOverviewCallToActionProps } from './ContentOverviewCallToActionProps';

type ContentOverviewCertificateOfCompletionProps = ContentOverviewCallToActionProps & {
	fields: {
		CertificateOfCompletion?: Field<boolean>;
	};
};

export default function ContentOverviewCertificateOfCompletion(props: ContentOverviewCertificateOfCompletionProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();
	const WildCardRoute = useContext(WildCardRouteContext);

	if (!props.fields.CertificateOfCompletion?.value) {
		return <></>;
	}

	const nestedProps = { ...props, fields: { ...props.fields, HideTitleSubtitle: true } };

	return (
		<FieldEditFrame
			itemId={WildCardRoute?.wildCardItemInfo?.Id ?? sitecoreContext?.itemId ?? undefined}
			fields={['CertificateOfCompletion']}
			header="Edit Certificate of Completion"
		>
			<EditorHelp text={'Click here to edit if the Certificate of Completion should be shown'} indent />
			<ContentOverviewCallToAction {...nestedProps} />
		</FieldEditFrame>
	);
}
